import generateMutation from 'graphql/mutations/product/ProductLabelBasicGenerateMutation.graphql';
import generateRangeMutation from 'graphql/mutations/product/ProductLabelBasicGenerateRangeMutation.graphql';

import hasValidationErrors from 'components/connectedForm/utils/hasValidationErrors';
import { createBackgroundJob } from 'utils/BackgroundJobs';
import { onDocumentPrintComplete, onDocumentPrintFailed } from 'utils/DocumentUtils';
import { getMutationProps, getRangeMutationProps } from 'actions/sales/DocumentAction';

const ProductLabelBasic = {
  type: 'Product',
  title: 'Product Label',
  formTitle: 'Print Product Labels',
  printFunctions: {
    generate,
    generateRange,
  },
  actions: [],
  configuration: {
    title: 'Product Label',
    reportType: 'PRODUCT_LABEL_BASIC',
    field: 'productLabelBasicDefault',
  },
};

export function generate(state, props, variables, returnUrl) {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    generateMutation,
    getMutationProps(state, props, variables, 'product'),
    props,
    returnUrl,
    'Generate Basic Product Labels',
    (job) => onDocumentPrintComplete(state, props, job)
  );
}

export function generateRange(state, props, variables, returnUrl) {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    generateRangeMutation,
    getRangeMutationProps(state, props, variables, 'products'),
    props,
    returnUrl,
    'Generate Basic Product Labels',
    (job) => onDocumentPrintComplete(state, props, job),
    (job) => onDocumentPrintFailed(state, props, job)
  );
}

export default ProductLabelBasic;
